import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { Control, Controller, useWatch } from "react-hook-form";
import { useEffect, useState } from "react";
import { endpointPrincipal } from "../../../../../../api/endPoints/endpointPrincipal/endpointPrincipal";
import { toast } from "react-toastify";

interface SelectFiliaisProps {
  name: string;
  control: Control<any>;
  label: string;
  idEmpresa?: number | string;
  disabled?: boolean;
}

interface FilialOption {
  id_filial: number;
  fantasia: string;
}

export const SelectFiliais = ({ name, control, label, idEmpresa, disabled = false }: SelectFiliaisProps) => {
  const [filiais, setFiliais] = useState<FilialOption[]>([]);
  const selectedValue = useWatch({
    control,
    name,
    defaultValue: ""
  });

  useEffect(() => {
    const carregarFiliais = async () => {
      if (!idEmpresa) {
        setFiliais([]);
        return;
      }

      try {
        const { data } = await endpointPrincipal.get(`empresas-filiais/empresa/${idEmpresa}`);
        
        setFiliais(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Erro ao carregar filiais:", error);
        toast.error("Erro ao carregar filiais");
        setFiliais([]);
      }
    };

    carregarFiliais();
  }, [idEmpresa]);

  return (
    <FormControl fullWidth size="small" sx={{ mb: 3 }}>
      <InputLabel>{label}</InputLabel>
      <Controller
        name={name}
        control={control}
        defaultValue=""
        render={({ field }) => (
          <Select
            {...field}
            label={label}
            disabled={disabled || !idEmpresa}
            value={selectedValue || ""}
            onChange={(e) => {
              field.onChange(e);
              if (!idEmpresa) {
                field.onChange("");
              }
            }}
          >
            <MenuItem value="">Selecione...</MenuItem>
            {filiais.map((filial) => (
              <MenuItem key={filial.id_filial} value={filial.id_filial}>
                {filial.fantasia}
              </MenuItem>
            ))}
          </Select>
        )}
      />
    </FormControl>
  );
}; 